Controller.$inject = [];

function Controller() {
    const self = this;
    self.isOpen = false;
}

export function HuiAccordionPanel() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <div class="hui-accordion-panel"
                    ng-class="{ 'open': $huiCtrl.isOpen }">
                    <ng-transclude></ng-transclude>
               </div>
            `;
        }
    }
}